// extracted by mini-css-extract-plugin
export var filterIncDec = "_4o-0";
export var leftBorder = "_4o-1";
export var rightBorder = "_4o-2";
export var stringInput = "_4o-3";